import HeroBasic from '../components/HeroBasic'
import Card from '../components/Card'
import InfoBox from '../components/InfoBox'

function BuildColabInfo() {
    var colabList = [
        {
            header: "PEER",
            body: "Public Employees for Environmental Responsibility."
        },
        {
            header: "EDGI",
            body: "Environmental Data & Governance Initiative."
        },
    ] 

    var colabCards = colabList.map((a, index) => 
        <InfoBox key={index} header={a.header}>
            <p>{a.body}</p>
        </InfoBox>
    )

    return <div className="grid">{colabCards}</div>
}



function Collaborators() {
    var heroTitle = "Collaborators"
    var heroSubtitle = "Organizations and contributors supporting the project."

    var cardHeader = "Collaborators"
    var colabList = BuildColabInfo()

    return (
        <div>
            <HeroBasic title={heroTitle} subtitle={heroSubtitle} />
            <Card header={cardHeader}>
                {colabList}
            </Card>
        </div>
    )
}

export default Collaborators